import React from "react";
import { Link } from "react-router-dom";
import "./CaseStudies.css";

function CaseStudies() {
  return (
    <section className="bx3-wrapper">
      <div className="bx3-container">

        <h2 className="bx3-title">Case Studies</h2>

        <div className="bx3-grid">

          <Link to="/Ifile" className="bx3-card">
            <div className="bx3-img-box">
              <img src="project-pic/ifileproduct2.jpg" alt="iFile" />
            </div>
            <div className="bx3-content">
              <h3 className="caseh">iFile Management System</h3>
              <p className="casep">
                AI-powered file management solution for smart and secure handling.
              </p>
              <span className="casebtn">Read More →</span>
            </div>
          </Link>

          <Link to="/plaza" className="bx3-card">
            <div className="bx3-img-box">
              <img src="case-study-img/tollplazaback.jpg" alt="plaza" />
            </div>
            <div className="bx3-content">
              <h3 className="caseh">Toll Plaza Management</h3>
              <p className="casep">
                Smart toll automation system improving efficiency and traffic flow.
              </p>
              <span className="casebtn">Read More →</span>
            </div>
          </Link>

          <Link to="/parking" className="bx3-card">
            <div className="bx3-img-box">
              <img src="case-study-img/parkintro.jpg" alt="parking" />
            </div>
            <div className="bx3-content">
              <h3 className="caseh">iParking System</h3>
              <p className="casep">
                Intelligent parking solution for seamless vehicle management.
              </p>
              <span className="casebtn">Read More →</span>
            </div>
          </Link>

        </div>
      </div>
    </section>
  );
}

export default CaseStudies;